import React, { useState } from 'react';
import {
    Form,
    Select,
    Row,
    Col,
    Input,
    Radio,
    Button,
    Divider,
    Collapse,
    message,
    theme,
    Typography,
} from 'antd';
import UploadPDF from '../../../components/upload/upload';
import DropDownMultiple from '../../../components/dropDownMultiple';
import ApiSelect from '../../../components/api-select/api-select';
import { MASTER_DATA_FIELD } from '../../../constants/masterData';
import { changeModel, masterDataAddDropDown, masterDataDropDownList, profileState } from '../../profile/profile.slice';
import { useDispatch, useSelector } from 'react-redux';
import { loginState } from '../../login/login.slice';
import { ExpandIcon, SkillsIcon, ToolsIcon } from '../../../assets/icons';

const { Option } = Select;

const OtherForm = () => {
    const [searchValue, setSearchValue] = useState('')
    const [page, setPage] = useState(0);
    const [status, setStatus] = useState("loading");
    const [skillsData, setSkillsData] = useState([])
    const [toolsData, setToolsData] = useState([])
    const {
        formButtonType,
        modelType,
        masterDataDropDown,
        isNext
    } = useSelector(profileState)
    const { useToken } = theme
    const { Text, Title } = Typography
    const { token } = useToken()
    const { userProfile } = useSelector(loginState)

    const jobTypes = [
        { label: 'Full Time', value: 'full-time' },
        { label: 'Part Time', value: 'part-time' },
        { label: 'Freelancing', value: 'freelancing' }
    ];
    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const onFinish = (values) => {
        console.log("🚀 ~ onFinish ~ values:", values)

    };
    const resetPage = () => {
        setPage(1);
    };

    // Watch the value of 'gender' (Any References)
    const anyReferences = Form.useWatch('gender', form);

    const fetchOptions = async (search = "", pageNumber = 1, model) => {
        setStatus("loading");
        setSearchValue(search);

        try {
            dispatch(changeModel(model))
            const result = await dispatch(
                masterDataDropDownList({
                    search: search,
                    id: model,
                    skip: pageNumber
                })
            ).unwrap(); // ⬅️ Get the actual payload

            const newData = Array.isArray(result?.data) ? result.data : [];


            setPage(pageNumber + 1);
            setStatus(newData.length === 0 ? "noData" : "loaded");
        } catch (error) {
            console.error("Dropdown fetch failed", error);
            setStatus("noData");
        }
    };

    async function addMasterData() {
        const result = await dispatch(
            masterDataAddDropDown({
                addData: {
                    type: 'manual',
                    data: {
                        name: searchValue,
                        logo:
                            modelType === 'tools'
                                ? 'https://pms-bucket123.s3.amazonaws.com/Layer_1_1689237094.svg'
                                : modelType === 'institute'
                                    ? 'https://pms-bucket123.s3.amazonaws.com/Group 35301_1689226177.svg'
                                    : '',
                        createdBy: userProfile?._id,
                    },
                },
                model: modelType,
            })
        )
        const data = result?.payload?.data

        if (data) {
            const { success, message: errorMessage } = data
            if (success) {
                dispatch(
                    masterDataDropDownList({
                        search: searchValue,
                        id: modelType,
                    })
                )
            } else {
                if (errorMessage) {
                    message.error(errorMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }
    // COLLAPSE MENU HEADER
    const CollapseLabel = ({ name, icon, description }) => (
        <Row
            align={'middle'}
            style={{
                columnGap: '20px',
                marginBottom: '18px',
            }}
        >
            <Row
                style={{
                    height: '50px',
                    width: '50px',
                    borderRadius: '10px',
                    padding: '12px',
                    backgroundColor: token.colorPalette.baseColor.tertiary,
                }}
                align={'middle'}
                justify={'center'}
            >
                <div
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '30px',
                    }}
                >
                    {icon}
                </div>
            </Row>
            <div>
                <Title
                    style={{
                        // fontSize: token.fontSizeHeading4,
                        fontSize: '18px',
                    }}
                >
                    {name}
                </Title>
                <Text className="sub-title" style={{ fontSize: '15px' }}>
                    {description}
                </Text>
            </div>
        </Row>
    )
    // COLLAPSE ITEMS
    const getItems = () => [
        {
            key: '1',
            label: (
                <CollapseLabel
                    name={`Add Skills ${skillsData?.length > 0 ? `(${skillsData?.length})` : ''
                        }`}
                    icon={
                        <SkillsIcon
                            color={token.colorPalette.baseColor.white}
                        />
                    }
                    description="Please add the skills suitable to your expertise."
                />
            ),
            children: (
                <>

                    <ApiSelect
                        // label="Search Skills*"
                        name={MASTER_DATA_FIELD.skills}
                        rules={
                            formButtonType !== 'draftButtonLoading'
                                ? [{ required: true, message: 'Please Select Field of skills' }]
                                : []
                        }
                        placeholder="Search a Field of skills"
                        tagRender={() => null}
                        rootClassName={[
                            'p-0-multiSelect',
                            skillsData?.length > 0
                                ? 'p-0-multiselect-setMargin'
                                : '',
                        ]}
                        onClick={() => {
                            resetPage();
                            fetchOptions("", 0, MASTER_DATA_FIELD.skills);
                        }}
                        onSelect={(e, options) => {
                            const trimSkills = options?.key.trimStart()
                            if (trimSkills?.length > 0) {
                                setSkillsData([
                                    ...skillsData,
                                    { label: trimSkills, value: e },
                                ])
                            }
                        }}
                        onDeselect={(e) => {
                            const removeData = [...skillsData]
                            removeData.splice(
                                removeData.findIndex(
                                    (item) => item.label === e
                                ),
                                1
                            )
                            setSkillsData(removeData)
                        }}
                        mode={"multiple"}
                        onSearch={(value) => {
                            resetPage();
                            fetchOptions(value, 0, MASTER_DATA_FIELD.skills);
                        }}
                        onScrollBottom={() => {
                            fetchOptions(searchValue, page, MASTER_DATA_FIELD.skills);
                        }}
                        dropdownRender={(menu, handleScroll) => (
                            <DropDownMultiple
                                handleScroll={handleScroll}
                                menu={menu}
                                searchValue={searchValue}
                                name={
                                    MASTER_DATA_FIELD.skills
                                }
                                addMasterData={() =>
                                    addMasterData()
                                }
                            />
                        )}
                        options={masterDataDropDown?.skills}
                        dropdownStatus={status}
                    />

                </>
            ),
        },
        {
            key: '2',
            label: (
                <CollapseLabel
                    name={`Add Tools ${toolsData?.length > 0 ? `(${toolsData?.length})` : ''
                        }`}
                    icon={
                        <ToolsIcon color={token.colorPalette.baseColor.white} />
                    }
                    description="Please add tools suitable to your hands-on experience."
                />
            ),
            children: (
                <>

                    <ApiSelect
                        // label="Search Skills*"
                        name={MASTER_DATA_FIELD.tools}
                        rules={
                            formButtonType !== 'draftButtonLoading'
                                ? [{ required: true, message: 'Please Select Field of tools' }]
                                : []
                        }
                        placeholder="Search a Field of tools"
                        tagRender={() => null}
                        rootClassName={[
                            'p-0-multiSelect',
                            skillsData?.length > 0
                                ? 'p-0-multiselect-setMargin'
                                : '',
                        ]}
                        onClick={() => {
                            resetPage();
                            fetchOptions("", 0, MASTER_DATA_FIELD.tools);
                        }}
                        onSelect={(e, options) => {
                            const trimSkills = options?.key.trimStart()
                            if (trimSkills?.length > 0) {
                                setToolsData([
                                    ...toolsData,
                                    { label: trimSkills, value: e },
                                ])
                            }
                        }}
                        onDeselect={(e) => {
                            const removeData = [...toolsData]
                            removeData.splice(
                                removeData.findIndex(
                                    (item) => item.label === e
                                ),
                                1
                            )
                            setToolsData(removeData)
                        }}
                        mode={"multiple"}
                        onSearch={(value) => {
                            resetPage();
                            fetchOptions(value, 0, MASTER_DATA_FIELD.tools);
                        }}
                        onScrollBottom={() => {
                            fetchOptions(searchValue, page, MASTER_DATA_FIELD.tools);
                        }}
                        dropdownRender={(menu, handleScroll) => (
                            <DropDownMultiple
                                handleScroll={handleScroll}
                                menu={menu}
                                searchValue={searchValue}
                                name={
                                    MASTER_DATA_FIELD.tools
                                }
                                addMasterData={() =>
                                    addMasterData()
                                }
                            />
                        )}
                        options={masterDataDropDown?.tools}
                        dropdownStatus={status}
                    />

                </>
            ),
        },
    ]



    return (
        <Form layout="vertical" form={form} onFinish={onFinish}>
            <Row style={{ rowGap: '20px' }} justify="space-between" gutter={16}>
                <Col span={12}>
                    <Form.Item label="Job Type Preference" name="jobTypePreference" colon={false}>
                        <Select placeholder="Select Job Type">
                            {jobTypes.map((job) => (
                                <Select.Option key={job.value} value={job.value}>
                                    {job.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>


                <Col span={12}>
                    <Form.Item label="Any References" name="gender">
                        <Radio.Group style={{ width: '100%' }}>
                            <Radio value="true">Yes</Radio>
                            <Radio value="false">No</Radio>
                        </Radio.Group>
                    </Form.Item>
                </Col>

                {anyReferences === 'true' && (
                    <>
                        <Col span={12}>
                            <Form.Item label="References Name" name="references" colon={false}>
                                <Input placeholder="Enter Reference Name" />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item label="References Email" name="referencesEmail" colon={false}>
                                <Input placeholder="Enter Reference Email" />
                            </Form.Item>
                        </Col>
                    </>
                )}

                <Col span={12}>
                    <Form.Item label="Aadhar Card" name="aadharCard" colon={false}>
                        <UploadPDF />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item label="PAN Card" name="panCard" colon={false}>
                        <UploadPDF />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label="Other Attachments" name="additionalAttachments" colon={false}>
                        <UploadPDF />
                    </Form.Item>
                </Col>
            </Row>
            <Collapse
                bordered={false}
                defaultActiveKey={['1', '2']}
                expandIcon={({ isActive }) => {
                    return <ExpandIcon isActive={!isActive} />
                }}
                expandIconPosition="right"
                style={{
                    backgroundColor: 'transparent',
                }}
                items={getItems()}
            />
            <Divider style={{ marginTop: '0px' }} />
            <div style={{ display: "flex", justifyContent: 'end', marginTop: "15px" }}>

                <Button htmlType="submit">Submit</Button>
            </div>
        </Form>
    );
};

export default OtherForm;
